import { Fetcher } from '@this/src/util';
import type { AvailableRequestForm } from '@this/src/domain/available_request_form';
import type { DepartmentResponseArgs } from '@this/src/domain/department/department2';
import type UserJson from '../../../../domain/user/user_json';

export interface ArrangementRequestNewResponse {
  members: UserJson[];
  departments: DepartmentResponseArgs[];
  use_bulk_ticket: boolean;
  show_ex: boolean;
  projects: never;
  notified_users: UserJson[];
  car_type: [string, string][];
  item_type: [string, string][];
  available_request_forms: AvailableRequestForm[];
}

export interface ArrangementRequestResponse {
  redirect_path: string;
}

interface ArrangementRequestInfoSubmitParams {
  need_hotel: boolean;
  need_shinkansen: boolean;
  need_domestic_flight: boolean;
  need_foreign_flight: boolean;
  need_rentalcar: boolean;
  need_other: boolean;
  internal_number: string;
  project_ids: string[];
  notified_user_ids: (string | undefined)[];
  [key: string]: unknown;
}

interface SearchResultConfirmParams {
  [key: string]:
    | string
    | number
    | boolean
    | {
        [key: string]: any;
      }
    | null
    | undefined;
}

export interface SubmitParams {
  email: string;
  origin: string;
  destination: string;
  outdate?: string;
  outhour?: string;
  outmin?: string;
  outtype: 'arrival' | 'departure';
  homedate?: string;
  homehour?: string;
  homemin?: string;
  hometype: 'arrival' | 'departure';
  peoplenum: number;
  first_name: string;
  last_name: string;
  passport_number: string;
  passport_expire: string;
  passport_issued_country: string;
  hotel_location: string;
  memo: string;
  itinerary_description: string;
  traveler_informations: unknown[]; // from traveler_list.d.ts
  info: ArrangementRequestInfoSubmitParams;
  search_query_id: number | null;
  result: SearchResultConfirmParams | null;
  is_foreign: boolean;
  is_trip_foreign: boolean;
}

/**
 * アレンジメントリクエストフォーム表示用の初期データを取得
 */
export const fetchArrangementRequestInitialData = async (): Promise<ArrangementRequestNewResponse> => {
  return Fetcher.get<ArrangementRequestNewResponse>('/arrangement_requests/new');
};

/**
 * アレンジメントリクエストを送信
 */
export const submitArrangementRequest = async (params: SubmitParams): Promise<ArrangementRequestResponse> => {
  return Fetcher.post<ArrangementRequestResponse>('/arrangement_requests.json', params);
};
